

// import React, { useEffect, useState } from "react";
// import axios from "../../api/axiosAuth";
// import { useAuth } from "../../context/AuthContext";
// import "../../style/ModuloExpulsiones.css";

// const API = "http://localhost:5001/api";

// export default function ModuloExpulsiones() {
//   const { token } = useAuth();
//   const headers = { headers: { Authorization: `Bearer ${token}` } };

//   const [tab, setTab] = useState("registrar");

//   /* ===============================
//      🏫 ÁMBITO
//   =============================== */
//   const [sedes, setSedes] = useState([]);
//   const [sedeSeleccionada, setSedeSeleccionada] = useState("all"); // all = todas

//   /* ===============================
//      📝 REGISTRO
//   =============================== */
//   const [estudiantes, setEstudiantes] = useState([]);
//   const [estudianteId, setEstudianteId] = useState("");
//   const [manuales, setManuales] = useState([]);
//   const [manualId, setManualId] = useState("");
//   const [descripcion, setDescripcion] = useState("");
//   const [fechaInicio, setFechaInicio] = useState("");
//   const [fechaFin, setFechaFin] = useState("");
//   const [loading, setLoading] = useState(false);

//   /* ===============================
//      🔍 CONSULTA
//   =============================== */
//   const [expulsiones, setExpulsiones] = useState([]);
//   const [loadingConsulta, setLoadingConsulta] = useState(false);

//   /* ===============================
//      🚀 CARGA INICIAL
//   =============================== */
//   useEffect(() => {
//     if (!token) return;

//     // Sedes
//     axios.get(`${API}/expulsiones/sedes`, headers)
//       .then(r => setSedes(r.data))
//       .catch(() => setSedes([]));

//     // Manuales
//     axios.get(`${API}/manual-convivencia`, headers)
//       .then(r => setManuales(r.data))
//       .catch(() => setManuales([]));

//     // Consulta inicial: todas las sedes
//     consultar();
//   }, [token]);

//   /* ===============================
//      🎓 ESTUDIANTES POR SEDE
//   =============================== */
//   useEffect(() => {
//     if (!token || !sedeSeleccionada) return;

//     // Si se filtra por "all" no traer estudiantes
//     if (sedeSeleccionada === "all") {
//       setEstudiantes([]);
//       setEstudianteId("");
//       return;
//     }

//     axios.get(`${API}/expulsiones/estudiantes/${sedeSeleccionada}`, headers)
//       .then(r => setEstudiantes(r.data))
//       .catch(() => setEstudiantes([]));

//     setEstudianteId("");
//   }, [sedeSeleccionada, token]);

//   /* ===============================
//      ➕ REGISTRAR EXPULSIÓN
//   =============================== */
//   const registrar = async () => {
//     if (!estudianteId || !manualId || !fechaInicio || !fechaFin) {
//       return alert("⚠️ Complete todos los campos obligatorios");
//     }

//     setLoading(true);
//     try {
//       await axios.post(
//         `${API}/expulsiones`,
//         {
//           estudiante_id: estudianteId,
//           falta_id: manualId,
//           descripcion,
//           fecha_inicio: fechaInicio,
//           fecha_fin: fechaFin
//         },
//         headers
//       );

//       alert("✅ Expulsión registrada correctamente");

//       // Limpiar formulario
//       setEstudianteId("");
//       setManualId("");
//       setDescripcion("");
//       setFechaInicio("");
//       setFechaFin("");

//       // Actualizar consulta
//       consultar(sedeSeleccionada === "all" ? null : sedeSeleccionada);

//     } catch (error) {
//       console.error(error);
//       alert("❌ Error al registrar expulsión");
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ===============================
//      📄 CONSULTAR EXPULSIONES
//   =============================== */
//   const consultar = async (sede = null) => {
//     setLoadingConsulta(true);
//     try {
//       const params = sede ? { sede_id: sede } : {};
//       const res = await axios.get(`${API}/expulsiones`, { ...headers, params });
//       setExpulsiones(res.data);
//     } catch (error) {
//       console.error(error);
//       alert("❌ Error al consultar expulsiones");
//     } finally {
//       setLoadingConsulta(false);
//     }
//   };

//   /* ===============================
//      🔘 FILTRO POR SEDE
//   =============================== */
//   const handleSedeChange = (e) => {
//     const value = e.target.value;
//     setSedeSeleccionada(value);
//     consultar(value === "all" ? null : value);
//   };

//   return (
//     <div className="modulo-expulsiones">
//       <h2>📕 Gestión de Expulsiones</h2>

//       <div className="tabs">
//         <button
//           className={tab === "registrar" ? "active" : ""}
//           onClick={() => setTab("registrar")}
//         >
//           Registrar
//         </button>
//         <button
//           className={tab === "consultar" ? "active" : ""}
//           onClick={() => setTab("consultar")}
//         >
//           Consultar
//         </button>
//       </div>

//       {/* ===============================
//           🏫 ÁMBITO / FILTRO
//       =============================== */}
//       <div className="filtros">
//         <label>🏫 Ámbito:</label>
//         <select value={sedeSeleccionada} onChange={handleSedeChange}>
//           <option value="all">Todas las sedes</option>
//           <option value="tenant">Colegio principal</option>
//           {sedes.map(s => (
//             <option key={s.id} value={s.id}>{s.nombre}</option>
//           ))}
//         </select>
//       </div>

//       {/* ===============================
//           📝 REGISTRAR
//       =============================== */}
//       {tab === "registrar" && (
//         <div className="registro">
//           <label>🎓 Estudiante:</label>
//           <select value={estudianteId} onChange={e => setEstudianteId(e.target.value)}>
//             <option value="">Seleccione estudiante</option>
//             {estudiantes.map(e => (
//               <option key={e.id} value={e.id}>
//                 {e.apellidos_estudiante} {e.nombres_estudiante} | {e.grado}-{e.grupo}
//               </option>
//             ))}
//           </select>

//           <label>📘 Norma:</label>
//           <select value={manualId} onChange={e => setManualId(e.target.value)}>
//             <option value="">Seleccione norma</option>
//             {manuales.map(m => (
//               <option key={m.id} value={m.id}>
//                 {m.nombre_completo}  {/* Nombre completo */}
//               </option>
//             ))}
//           </select>

//           <label>📝 Descripción:</label>
//           <textarea value={descripcion} onChange={e => setDescripcion(e.target.value)} />

//           <div className="fechas">
//             <input type="date" value={fechaInicio} onChange={e => setFechaInicio(e.target.value)} />
//             <input type="date" value={fechaFin} onChange={e => setFechaFin(e.target.value)} />
//           </div>

//           <button disabled={loading} onClick={registrar}>
//             {loading ? "Procesando..." : "Confirmar expulsión"}
//           </button>
//         </div>
//       )}

//       {/* ===============================
//           📄 CONSULTAR
//       =============================== */}
//       {tab === "consultar" && (
//         <div className="consulta">
//           {loadingConsulta && <p>Consultando...</p>}

//           <table>
//             <thead>
//               <tr>
//                 <th>Estudiante</th>
//                 <th>Grado</th>
//                 <th>Norma</th>
//                 <th>Estado</th>
//                 <th>Inicio</th>
//                 <th>Fin</th>
//               </tr>
//             </thead>
//             <tbody>
//               {expulsiones.map(e => (
//                 <tr key={e.id}>
//                   <td>{e.nombres_estudiante} {e.apellidos_estudiante}</td>
//                   <td>{e.grado}-{e.grupo}</td>
//                   <td>{e.falta_completa || e.falta_descripcion}</td>
//                   <td>{e.estado}</td>
//                   <td>{e.fecha_inicio?.slice(0, 10)}</td>
//                   <td>{e.fecha_fin?.slice(0, 10)}</td>
//                 </tr>
//               ))}
//               {expulsiones.length === 0 && (
//                 <tr>
//                   <td colSpan="6">No hay expulsiones registradas</td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// }


// //
// import React, { useEffect, useState } from "react";
// import axios from "../../api/axiosAuth";
// import { useAuth } from "../../context/AuthContext";
// import "../../style/ModuloExpulsiones.css";

// // const API = "http://localhost:5001/api";

// // Configuración para conectar con el servidor en AWS
// const API = process.env.REACT_APP_API_URL || "http://3.236.217.225:5001/api";

// export default function ModuloExpulsiones() {
//   const { token } = useAuth();
//   const headers = { headers: { Authorization: `Bearer ${token}` } };

//   const [tab, setTab] = useState("registrar");

//   const [sedes, setSedes] = useState([]);
//   const [sedeSeleccionada, setSedeSeleccionada] = useState("all");

//   const [estudiantes, setEstudiantes] = useState([]);
//   const [estudianteId, setEstudianteId] = useState("");

//   const [manuales, setManuales] = useState([]);
//   const [manualId, setManualId] = useState("");

//   const [descripcion, setDescripcion] = useState("");
//   const [fechaInicio, setFechaInicio] = useState("");
//   const [fechaFin, setFechaFin] = useState("");

//   const [loading, setLoading] = useState(false);

//   const [expulsiones, setExpulsiones] = useState([]);
//   const [loadingConsulta, setLoadingConsulta] = useState(false);

//   /* ===============================
//      🚀 INICIAL
//   =============================== */
//   useEffect(() => {
//     if (!token) return;

//     axios.get(`${API}/expulsiones/sedes`, headers)
//       .then(r => setSedes(r.data || []))
//       .catch(() => setSedes([]));

//     axios.get(`${API}/manual-convivencia`, headers)
//       .then(r => setManuales(r.data || []))
//       .catch(() => setManuales([]));

//     consultar();
//   }, [token]);

//   /* ===============================
//      🎓 ESTUDIANTES
//   =============================== */
//   useEffect(() => {
//     if (!token || !sedeSeleccionada) return;

//     if (sedeSeleccionada === "all") {
//       setEstudiantes([]);
//       setEstudianteId("");
//       return;
//     }

//     axios.get(`${API}/expulsiones/estudiantes/${sedeSeleccionada}`, headers)
//       .then(r => {
//         const lista = r.data || [];
//         setEstudiantes(lista);
//       })
//       .catch(() => setEstudiantes([]));

//     setEstudianteId("");
//   }, [sedeSeleccionada, token]);

//   /* ===============================
//      ➕ REGISTRAR
//   =============================== */
//   const registrar = async () => {
//     if (!estudianteId || !manualId || !fechaInicio || !fechaFin) {
//       return alert("⚠️ Complete todos los campos obligatorios");
//     }

//     if (fechaFin < fechaInicio) {
//       return alert("⚠️ La fecha fin no puede ser menor que la fecha inicio");
//     }

//     const payload = {
//       estudiante_id: Number(estudianteId), // 🔥 IMPORTANTE
//       falta_id: Number(manualId),
//       descripcion,
//       fecha_inicio: fechaInicio,
//       fecha_fin: fechaFin
//     };

//     console.log("🚀 Enviando:", payload);

//     setLoading(true);
//     try {
//       await axios.post(`${API}/expulsiones`, payload, headers);

//       alert("✅ Expulsión registrada correctamente");

//       setEstudianteId("");
//       setManualId("");
//       setDescripcion("");
//       setFechaInicio("");
//       setFechaFin("");

//       consultar(sedeSeleccionada === "all" ? null : sedeSeleccionada);

//     } catch (error) {
//       console.error("❌ ERROR BACKEND:", error.response?.data);
//       alert(error.response?.data?.message || "Error al registrar expulsión");
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ===============================
//      📄 CONSULTAR
//   =============================== */
//   const consultar = async (sede = null) => {
//     setLoadingConsulta(true);
//     try {
//       const params = sede ? { sede_id: sede } : {};
//       const res = await axios.get(`${API}/expulsiones`, { ...headers, params });
//       setExpulsiones(res.data || []);
//     } catch (error) {
//       console.error("❌ ERROR CONSULTA:", error.response?.data);
//       setExpulsiones([]);
//     } finally {
//       setLoadingConsulta(false);
//     }
//   };

//   const handleSedeChange = (e) => {
//     const value = e.target.value;
//     setSedeSeleccionada(value);
//     consultar(value === "all" ? null : value);
//   };

//   return (
//     <div className="modulo-expulsiones">
//       <h2>📕 Gestión de Expulsiones</h2>

//       <div className="tabs">
//         <button className={tab === "registrar" ? "active" : ""} onClick={() => setTab("registrar")}>
//           Registrar
//         </button>
//         <button className={tab === "consultar" ? "active" : ""} onClick={() => setTab("consultar")}>
//           Consultar
//         </button>
//       </div>

//       {/* FILTRO */}
//       <div className="filtros">
//         <label>🏫 Ámbito:</label>
//         <select value={sedeSeleccionada} onChange={handleSedeChange}>
//           <option value="all">Todas las sedes</option>
//           <option value="tenant">Colegio principal</option>
//           {sedes.map(s => (
//             <option key={s.id} value={s.id}>{s.nombre}</option>
//           ))}
//         </select>
//       </div>

//       {/* REGISTRAR */}
//       {tab === "registrar" && (
//         <div className="registro">

//           <label>🎓 Estudiante:</label>
//           <select
//             value={estudianteId}
//             onChange={e => setEstudianteId(e.target.value)}
//           >
//             <option value="">Seleccione estudiante</option>

//             {estudiantes.map(e => (
//               <option key={e.id} value={e.id}>
//                 {e.apellidos_estudiante} {e.nombres_estudiante} | {e.grado}-{e.grupo}
//               </option>
//             ))}
//           </select>

//           <label>📘 Norma:</label>
//           <select value={manualId} onChange={e => setManualId(e.target.value)}>
//             <option value="">Seleccione norma</option>
//             {manuales.map(m => (
//               <option key={m.id} value={m.id}>
//                 {m.nombre_completo}
//               </option>
//             ))}
//           </select>

//           <label>📝 Descripción:</label>
//           <textarea value={descripcion} onChange={e => setDescripcion(e.target.value)} />

//           <div className="fechas">
//             <input type="date" value={fechaInicio} onChange={e => setFechaInicio(e.target.value)} />
//             <input type="date" value={fechaFin} onChange={e => setFechaFin(e.target.value)} />
//           </div>

//           <button disabled={loading} onClick={registrar}>
//             {loading ? "Procesando..." : "Confirmar expulsión"}
//           </button>
//         </div>
//       )}

//       {/* CONSULTAR */}
//       {tab === "consultar" && (
//         <div className="consulta">
//           {loadingConsulta && <p>Consultando...</p>}

//           <table>
//             <thead>
//               <tr>
//                 <th>Estudiante</th>
//                 <th>Grado</th>
//                 <th>Norma</th>
//                 <th>Estado</th>
//                 <th>Inicio</th>
//                 <th>Fin</th>
//               </tr>
//             </thead>
//             <tbody>
//               {expulsiones.map(e => (
//                 <tr key={e.id}>
//                   <td>{e.nombres_estudiante} {e.apellidos_estudiante}</td>
//                   <td>{e.grado}-{e.grupo}</td>
//                   <td>{e.falta_completa || e.falta_descripcion}</td>
//                   <td>{e.estado}</td>
//                   <td>{e.fecha_inicio?.slice(0, 10)}</td>
//                   <td>{e.fecha_fin?.slice(0, 10)}</td>
//                 </tr>
//               ))}

//               {expulsiones.length === 0 && (
//                 <tr>
//                   <td colSpan="6">No hay expulsiones registradas</td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// }


import React, { useEffect, useState, useMemo } from "react";
import axios from "../../api/axiosAuth";
import { useAuth } from "../../context/AuthContext";
import { API } from "../config"; // ✅ Importación centralizada
import "../../style/ModuloExpulsiones.css";

export default function ModuloExpulsiones() {
  const { token } = useAuth();
  
  // Memorizamos los headers para evitar re-renderizados innecesarios
  const headers = useMemo(() => ({
    headers: { Authorization: `Bearer ${token}` }
  }), [token]);

  // Estados de interfaz
  const [tab, setTab] = useState("registrar");
  const [loading, setLoading] = useState(false);
  const [loadingConsulta, setLoadingConsulta] = useState(false);

  // Estados de datos
  const [sedes, setSedes] = useState([]);
  const [sedeSeleccionada, setSedeSeleccionada] = useState("all");
  const [estudiantes, setEstudiantes] = useState([]);
  const [manuales, setManuales] = useState([]);
  const [expulsiones, setExpulsiones] = useState([]);

  // Estados del formulario
  const [estudianteId, setEstudianteId] = useState("");
  const [manualId, setManualId] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");

  /* ===============================
      🚀 CARGA INICIAL
  =============================== */
  useEffect(() => {
    if (!token) return;

    // Cargar Sedes
    axios.get(`${API}/expulsiones/sedes`, headers)
      .then(r => setSedes(r.data || []))
      .catch(() => setSedes([]));

    // Cargar Manual de Convivencia (Normas)
    axios.get(`${API}/manual-convivencia`, headers)
      .then(r => setManuales(r.data || []))
      .catch(() => setManuales([]));

    consultar();
  }, [token, headers]);

  /* ===============================
      🎓 CARGA DE ESTUDIANTES
  =============================== */
  useEffect(() => {
    if (!token || !sedeSeleccionada) return;

    if (sedeSeleccionada === "all") {
      setEstudiantes([]);
      setEstudianteId("");
      return;
    }

    // Cargamos estudiantes según la sede o el tenant principal
    axios.get(`${API}/expulsiones/estudiantes/${sedeSeleccionada}`, headers)
      .then(r => {
        setEstudiantes(r.data || []);
      })
      .catch(() => setEstudiantes([]));

    setEstudianteId("");
  }, [sedeSeleccionada, token, headers]);

  /* ===============================
      ➕ REGISTRAR EXPULSIÓN
  =============================== */
  const registrar = async () => {
    if (!estudianteId || !manualId || !fechaInicio || !fechaFin) {
      return alert("⚠️ Complete todos los campos obligatorios");
    }

    if (new Date(fechaFin) < new Date(fechaInicio)) {
      return alert("⚠️ La fecha fin no puede ser menor que la fecha inicio");
    }

    const payload = {
      estudiante_id: Number(estudianteId),
      falta_id: Number(manualId),
      descripcion,
      fecha_inicio: fechaInicio,
      fecha_fin: fechaFin
    };

    setLoading(true);
    try {
      await axios.post(`${API}/expulsiones`, payload, headers);
      alert("✅ Expulsión registrada correctamente");

      // Limpiar formulario
      setEstudianteId("");
      setManualId("");
      setDescripcion("");
      setFechaInicio("");
      setFechaFin("");

      // Refrescar tabla
      consultar(sedeSeleccionada === "all" ? null : sedeSeleccionada);
    } catch (error) {
      console.error("❌ ERROR BACKEND:", error.response?.data);
      alert(error.response?.data?.message || "Error al registrar expulsión");
    } finally {
      setLoading(false);
    }
  };

  /* ===============================
      📄 CONSULTAR EXPULSIONES
  =============================== */
  const consultar = async (sede = null) => {
    setLoadingConsulta(true);
    try {
      const params = sede && sede !== "all" ? { sede_id: sede } : {};
      const res = await axios.get(`${API}/expulsiones`, { ...headers, params });
      setExpulsiones(res.data || []);
    } catch (error) {
      console.error("❌ ERROR CONSULTA:", error.response?.data);
      setExpulsiones([]);
    } finally {
      setLoadingConsulta(false);
    }
  };

  const handleSedeChange = (e) => {
    const value = e.target.value;
    setSedeSeleccionada(value);
    consultar(value);
  };

  return (
    <div className="modulo-expulsiones">
      <header className="expulsiones-header">
        <h2>📕 Gestión de Expulsiones</h2>
      </header>

      <div className="tabs">
        <button 
          className={tab === "registrar" ? "active" : ""} 
          onClick={() => setTab("registrar")}
        >
          Registrar Nueva
        </button>
        <button 
          className={tab === "consultar" ? "active" : ""} 
          onClick={() => setTab("consultar")}
        >
          Historial / Consultar
        </button>
      </div>

      {/* SECCIÓN DE FILTROS (Global para ambos tabs) */}
      <div className="filtros-container">
        <label>🏫 Filtrar por Sede:</label>
        <select value={sedeSeleccionada} onChange={handleSedeChange}>
          <option value="all">Todas las sedes</option>
          <option value="tenant">Colegio Principal</option>
          {sedes.map(s => (
            <option key={s.id} value={s.id}>{s.nombre}</option>
          ))}
        </select>
      </div>

      {/* CONTENIDO: REGISTRAR */}
      {tab === "registrar" && (
        <div className="form-registro-expulsion animate-in">
          <div className="form-group">
            <label>🎓 Estudiante:</label>
            <select
              value={estudianteId}
              onChange={e => setEstudianteId(e.target.value)}
              disabled={sedeSeleccionada === "all"}
            >
              <option value="">
                {sedeSeleccionada === "all" 
                  ? "Seleccione una sede primero" 
                  : `Seleccione estudiante (${estudiantes.length} encontrados)`}
              </option>
              {estudiantes.map(e => (
                <option key={e.id} value={e.id}>
                  {e.apellidos_estudiante} {e.nombres_estudiante} — {e.grado}°{e.grupo}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>📘 Norma / Falta (Manual de Convivencia):</label>
            <select value={manualId} onChange={e => setManualId(e.target.value)}>
              <option value="">Seleccione la norma infringida</option>
              {manuales.map(m => (
                <option key={m.id} value={m.id}>
                  {m.nombre_completo || m.descripcion}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>📝 Observaciones adicionales:</label>
            <textarea 
              value={descripcion} 
              onChange={e => setDescripcion(e.target.value)} 
              placeholder="Detalles del incidente..."
            />
          </div>

          <div className="fechas-grid">
            <div className="form-group">
              <label>📅 Fecha Inicio:</label>
              <input type="date" value={fechaInicio} onChange={e => setFechaInicio(e.target.value)} />
            </div>
            <div className="form-group">
              <label>📅 Fecha Fin:</label>
              <input type="date" value={fechaFin} onChange={e => setFechaFin(e.target.value)} />
            </div>
          </div>

          <button 
            className="btn-confirmar" 
            disabled={loading} 
            onClick={registrar}
          >
            {loading ? "Procesando..." : "Confirmar Registro de Expulsión"}
          </button>
        </div>
      )}

      {/* CONTENIDO: CONSULTAR */}
      {tab === "consultar" && (
        <div className="tabla-consulta animate-in">
          {loadingConsulta ? (
            <div className="loader">Cargando registros...</div>
          ) : (
            <div className="table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>Estudiante</th>
                    <th>Grado</th>
                    <th>Falta / Norma</th>
                    <th>Estado</th>
                    <th>Periodo</th>
                  </tr>
                </thead>
                <tbody>
                  {expulsiones.map(exp => (
                    <tr key={exp.id}>
                      <td>
                        <strong>{exp.nombres_estudiante} {exp.apellidos_estudiante}</strong>
                      </td>
                      <td>{exp.grado}°{exp.grupo}</td>
                      <td>
                        <span className="text-truncate" title={exp.falta_completa}>
                          {exp.falta_completa || exp.falta_descripcion}
                        </span>
                      </td>
                      <td>
                        <span className={`badge ${exp.estado?.toLowerCase()}`}>
                          {exp.estado}
                        </span>
                      </td>
                      <td>
                        <small>
                          {exp.fecha_inicio?.slice(0, 10)} al {exp.fecha_fin?.slice(0, 10)}
                        </small>
                      </td>
                    </tr>
                  ))}
                  {expulsiones.length === 0 && (
                    <tr>
                      <td colSpan="5" className="no-data">No se encontraron expulsiones registradas.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
}